module.exports = __webpack_public_path__ + "img/c4.46b936b4.webp";